let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9d87N")).then(() => parcelRequire('7ygbc'));